module.exports = __webpack_public_path__ + "static/media/OBE_hero-min.12cd019e.jpg";